import SlideshowIcon from '@mui/icons-material/Slideshow';
import { Avatar, Box, Button, Chip, CircularProgress, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip } from '@mui/material';
import { getLocaleDateWithTimeCustom, getUserFullName, highlightText, sortByProperty } from 'app/utils/appHelpers';
import config from 'config';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentMeeting } from 'stores/meeting';
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import WatchingMeetingDataTableFilter from './WatchingMeetingDataTableFilter';
import WatchingMeetingDataTableToolbar from './WatchingMeetingDataTableToolbar';
import { useNavigate } from 'react-router-dom';
import { useJumboLayoutSidebar } from '@jumbo/hooks';
import { getObjectListByPropertyApi } from 'api/general';
import { MEETING_USER } from 'app/utils/constants/customConstant';


function WatchingMeetingDataTable({ mainData, column, pageTitle }) {

    const dispatch = useDispatch();
    const { data: userList, isLoading: userLoading } = useSelector(state => state.user);

    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const unitList = useSelector(state => state.unit.data || []);
    const [data, setData] = useState(mainData);
    const [data2, setData2] = useState(mainData);
    const navigate = useNavigate();
    const [highlightQuery, setHighlightQuery] = useState('');


    useEffect(() => {
        const sortedData = [...mainData].sort((a, b) => {
            if (a.statFinish === 0 && b.statFinish !== 0) return -1;
            if (a.statFinish !== 0 && b.statFinish === 0) return 1;
            return 0;
        });

        setData(sortedData);
        setData2(sortedData);
    }, [mainData]);

    const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();

    const handleWatchingButtonClick = async (meeting) => {

        const resultMeetingMembers = await getObjectListByPropertyApi(MEETING_USER, "meetingId", meeting.id);
        let data = resultMeetingMembers.data;
        data = data.filter(x => x.type === 1)
        data = sortByProperty(data, "indexNo");
        let mUsers = []

        data.forEach(element => {
            const user = userList.find(item => item.id === element.userId);
            mUsers.push(user)
        });

        const updatedMeeting = {
            ...meeting,
            users: mUsers,
        };
        dispatch(setCurrentMeeting(updatedMeeting));

        navigate('/previousPage/watching');
        setSidebarOptions({ open: false })
    }

    const handleRequestSort = (event, property) => {
        const tempOrderBy = property;
        let tempOrder = 'desc';

        if (orderBy === property && order === 'desc') {
            tempOrder = 'asc';
        }

        const tempdata =
            tempOrder === 'desc'
                ? data.sort((a, b) => (b[tempOrderBy] < a[tempOrderBy] ? -1 : 1))
                : data.sort((a, b) => (a[tempOrderBy] < b[tempOrderBy] ? -1 : 1));

        setData(tempdata);
        // dispatch(setMeetingListOfTheUser(tempdata));
        setOrder(tempOrder);
        setOrderBy(tempOrderBy);

    };

    const DataTableHead = ({ onRequestSort, customColumnData }) => {

        const createSortHandler = property => event => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <TableRow>
                    {customColumnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                align={column.numeric}
                                padding={column.disablePadding ? 'none' : 'normal'}
                            >
                                <Tooltip
                                    title="Sırala"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    };




    const { baseFontSize, fabStyle, paginationStyle, buttonStyle, iconFontSize, tableCellStyle } = useTemplateFontSettings();


    return (

        <Paper
            className="col-md-12"
        >
            <WatchingMeetingDataTableToolbar
                pageTitle={pageTitle}
                data2={data2}
                setData={setData}
                setHighlightQuery={setHighlightQuery}
            />
            <WatchingMeetingDataTableFilter data={data2} setFilterData={(data) => setData(data)} setPage={setPage} />
            <div className="flex-auto">
                <div className="table-responsive-material">
                    <Table className="table-responsive-material"

                        sx={{
                            '& th, & td': {
                                fontSize: baseFontSize
                            }
                        }}
                        size="small"
                    >
                        <DataTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={data.length}
                            customColumnData={column}
                        />

                        <TableBody>

                            {data !== undefined && data.length === 0 ? null : (
                                data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                    const user = userList.find(x => x.id === n.adminUserId);
                                    return (
                                        <TableRow hover key={"trO" + n.id} >
                                            <TableCell align="left" padding="normal">{highlightText(n.inst, highlightQuery)}</TableCell>
                                            <TableCell align="left" padding="normal">{highlightText(unitList.find(x => x.id === n.unitId)?.name || "Tanımsız Kurul/Kol/Komisyon", highlightQuery)}</TableCell>
                                            <TableCell align="left" padding="normal" sx={tableCellStyle}>{highlightText(`${n.meetingNo}`, highlightQuery)}</TableCell>
                                            <TableCell align="left" padding="normal" sx={tableCellStyle}>{getLocaleDateWithTimeCustom("tr", n.pdate)}</TableCell>
                                            <TableCell align="left" padding="none">
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <Avatar
                                                        style={{
                                                            ...fabStyle
                                                        }}
                                                        alt={user !== undefined ? user.name : ''}
                                                        src={
                                                            user && user.profileImageUrl
                                                                ? `${config.userAuthApiUrl}${user.profileImageUrl}`
                                                                : undefined
                                                        }
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src =
                                                                config.userAuthApiUrl + config.defaultProfileImageUrl;
                                                        }}
                                                    />
                                                    <span>{highlightText(getUserFullName(user), highlightQuery)}</span>
                                                </Box>
                                            </TableCell>
                                            <TableCell align="left" padding="none">
                                                {n.statFinish === 1 ? (
                                                    <Chip
                                                        label="Tamamlandı"
                                                        size="small"
                                                        color="success"
                                                        sx={{
                                                            mb: 1,
                                                            mt: 1,
                                                            height: '20px',
                                                            '& .MuiChip-label': {
                                                                fontSize: '10px',
                                                                paddingLeft: '4px',
                                                                paddingRight: '4px',
                                                            },
                                                        }}
                                                    />
                                                ) : (n.statVote === 1 || n.statReview === 1 || n.statVideo === 1) ? (
                                                    <Chip
                                                        label="İşleme Açık"
                                                        size="small"
                                                        color="info"
                                                        sx={{
                                                            mb: 1,
                                                            mt: 1,
                                                            height: '20px',
                                                            '& .MuiChip-label': {
                                                                fontSize: '10px',
                                                                paddingLeft: '4px',
                                                                paddingRight: '4px',
                                                            },
                                                        }}
                                                    />
                                                ) : (
                                                    <Chip
                                                        label="Tamamlanmadı"
                                                        size="small"
                                                        color="warning"
                                                        sx={{
                                                            mb: 1,
                                                            mt: 1,
                                                            height: '20px',
                                                            '& .MuiChip-label': {
                                                                fontSize: '10px',
                                                                paddingLeft: '4px',
                                                                paddingRight: '4px',
                                                            },
                                                        }}
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell align="center" padding="none">
                                                <Tooltip title="Toplantı İzle">
                                                    <Box component="span" sx={{ display: 'inline-flex' }}>
                                                        <Button
                                                            sx={buttonStyle}
                                                            onClick={async () => {
                                                                await handleWatchingButtonClick(n);
                                                            }}
                                                        >
                                                            <SlideshowIcon />
                                                        </Button>
                                                    </Box>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            )}
                            {data !== undefined && data.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        Toplantı Bulunamadı
                                    </TableCell>
                                </TableRow>
                            )}



                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    count={data.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={(e, page) => setPage(page)}
                                    onRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
                                    labelRowsPerPage={"Görüntülenecek Satır"}
                                    rowsPerPageOptions={[10, 50, 100, { label: "Tümü", value: -1 }]}
                                    showFirstButton
                                    showLastButton
                                    sx={paginationStyle}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
            </div>




        </Paper >
    )
}

export default WatchingMeetingDataTable